import axios from 'axios';
import { saveAs } from 'file-saver';
import * as quillToWord from 'quill-to-word';

export const downloadAsWord = async (quill, docTitle) => {
    
  const quillDelta = quill.getContents();
  console.log(quillDelta)
  var justHtml = quill.root.innerHTML;
  console.log(justHtml)

    const quillToWordConfig = {
      exportAs: 'blob'
    };
    console.log(quillDelta)
    const doc = await quillToWord.generateWord(quillDelta, quillToWordConfig);
    saveAs(doc, `${docTitle}.docx`);
  }

export const downloadTxtFile = (quill, docTitle) => {
    const element = document.createElement("a");
    const file = new Blob([quill.getText()], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = `${docTitle}.txt`
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
}  